// Canonical access rules for the whole Order Ahead section — Event Setup, the
// menu/item/location pages it links to, and the Orders pages.
//
// Sidebar visibility, route guards and in-page buttons all read these, so a
// control can never appear for somebody the routes would bounce.
//
// STORAGE NOTE. The Role editor shows all three checkboxes under one "Order
// Ahead" heading, but they are not all stored together:
//
//   ORDER_AHEAD_ACCESS  -> permissions.order_ahead
//   ORDER_AHEAD_ITEMS   -> permissions.ticketingReporting
//   ORDER_AHEAD_ORDERS  -> permissions.ticketingReporting
//
// The grouping is display-only (`permissionDisplaySection` in src/utils.ts), so
// existing roles never needed migrating. Read each value from the key below,
// not from the heading it appears under.

const has = (user: any, moduleKey: string, value: string) => {
  const granted: any[] = user?.role?.permissions?.[moduleKey] ?? [];
  return granted.some((entry) => entry?.value === value);
};

// Open Event Setup and view the menus, items and locations it lists.
//
// The `role_id === 1` branch is load-bearing, not a courtesy: role 1 (Ronin
// Admin) has an EMPTY `order_ahead` key, so an exact-match check alone would
// lock Ronin staff out of the page. Grant role 1 ORDER_AHEAD_ACCESS in the
// Role editor and this branch can be deleted.
export const canViewOrderAheadSetup = (user: any) =>
  user?.role_id === 1 || has(user, "order_ahead", "ORDER_AHEAD_ACCESS");

// Create, edit, clone and delete menus, items and locations.
//
// No admin branch here — role 1 holds ORDER_AHEAD_ITEMS like every other role
// that can manage, so the checkbox stays the single source of truth.
export const canManageOrderAhead = (user: any) =>
  has(user, "ticketingReporting", "ORDER_AHEAD_ITEMS");

// Open the Order Ahead Orders list and detail pages.
export const canViewOrderAheadOrders = (user: any) =>
  has(user, "ticketingReporting", "ORDER_AHEAD_ORDERS");
